module.exports = __webpack_public_path__ + "static/img/erweima1.febb503.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima1.gif
// module id = /54i
// module chunks = 1